"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Alert = {
    parts: ['container'],
    baseStyle: {
        container: {
            fontSize: 'md',
        },
    },
    variants: {
        success: function () {
            return {
                container: {
                    background: '#C0F1D5',
                    borderRadius: '6px',
                    width: '619px',
                },
            };
        },
        error: function () {
            return {
                container: {
                    background: '#FFB3B2',
                    borderRadius: '6px',
                    width: '619px',
                },
            };
        },
        info: function () {
            return {
                container: {
                    background: '#E6E8EA',
                    borderRadius: '6px',
                    width: '619px',
                },
            };
        },
    },
};
exports.default = Alert;
